import { render, staticRenderFns } from "./ProductUsage.vue?vue&type=template&id=90a8f78c"
import script from "./ProductUsage.vue?vue&type=script&lang=js"
export * from "./ProductUsage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports